// Load lazy chunks (signature pad, its font) from wherever main.js itself came
// from. Django serves the bundle from /static/frontend/js/ and, in production,
// from https://pdflink.to even on customer domains, so the build-time "/"
// would point chunk requests at the wrong place. Must be imported first.
const script = document.currentScript;
if (script && script.src) {
    // eslint-disable-next-line no-undef, camelcase
    __webpack_public_path__ = script.src.replace(/js\/[^/]*$/, '');
}
